import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Zap, Target, Users, Smartphone, Smile } from 'lucide-react';

function ProductPage() {
  const [showPage, setShowPage] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowPage(true), 200);
    return () => clearTimeout(t);
  }, []);

  const features = [
    {
      icon: Target,
      title: 'Goal Tracking',
      description: 'Set, monitor, and achieve your habits with intuitive tracking tools'
    },
    {
      icon: Zap,
      title: 'Smart Reminders',
      description: 'Get personalized notifications to keep you on track'
    },
    {
      icon: Users,
      title: 'Community Features',
      description: 'Share progress and stay motivated with our growing community'
    },
    {
      icon: Smile,
      title: 'Vibe Check',
      description: 'Make tracking fun with personalized moods'
    }
  ];

  return (
    <div className={`min-h-screen bg-gradient-to-b from-amber-50 to-white transition-opacity duration-1000 ${
      showPage ? 'opacity-100' : 'opacity-0'
    }`}>
      {/* Navigation */}
      <nav className="flex items-center justify-between p-6 max-w-6xl mx-auto">
        <Link to="/" className="text-amber-950 font-light text-2xl hover:text-amber-900 transition-colors">
          veyebe
        </Link>
        <Link to="/" className="flex items-center gap-2 text-amber-900 hover:text-amber-950 transition-colors">
          <ArrowLeft size={20} />
          Back
        </Link>
      </nav>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className={`text-center mb-16 transition-all duration-1000 delay-100 ${
          showPage ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <h1 className="text-5xl md:text-6xl font-light text-amber-950 mb-4">Our Product</h1>
          <p className="text-xl text-amber-900 font-light max-w-2xl mx-auto">
            A modern platform designed to help you build sustainable habits and achieve your goals.
          </p>
        </div>

        {/* Features Grid */}
        <div className={`grid md:grid-cols-2 gap-8 mb-16 transition-all duration-1000 delay-300 ${
          showPage ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div 
                key={index}
                className="p-8 bg-white rounded-lg border border-amber-100 hover:border-amber-300 transition-colors"
              >
                <IconComponent className="w-8 h-8 text-amber-950 mb-4" />
                <h3 className="text-2xl font-light text-amber-950 mb-2">{feature.title}</h3>
                <p className="text-amber-900 font-light">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className={`text-center py-12 border-t border-amber-200 transition-all duration-1000 delay-500 ${
          showPage ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <p className="text-lg text-amber-900 mb-6">Ready to start building your future?</p>
          <Link to="/" className="px-8 py-3 bg-amber-950 text-amber-50 rounded-lg hover:bg-amber-900 transition-colors font-light">
            Get Started
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProductPage;
